<template>
  <div>
    <div class="push">
      <div v-if="!hideSearchBar" class="input-group input-group-lg">
        <input type="text" ref="searchInput" @input="search" class="form-control" :placeholder="`Zoek ${itemLabelSingular}...`">
        <div class="input-group-btn">
          <button type="button" class="btn btn-secondary" v-if="filter" @click="clearFilter">
            <i class="fa fa-times"></i>
          </button>
          <button type="submit" class="btn btn-secondary">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="block block-themed">
      <div class="block-header bg-primary-light">
        <div class="block-title">
          <strong>{{this.currentStart}}-{{this.currentEnd}}</strong> van <strong>{{this.totalRows}}</strong> {{itemLabelPlural}}
        </div>
        <div class="block-options">
          <slot name="before-block-options"></slot>

          <button type="button" class="btn-block-option" v-if="sortBy" @click="sortBy = null">
            <i class="si si-close"></i>
          </button>
          <button type="button" class="btn-block-option" @click="previous">
            <i class="si si-arrow-left"></i>
          </button>
          <button type="button" class="btn-block-option" @click="next">
            <i class="si si-arrow-right"></i>
          </button>
          <button type="button" class="btn-block-option" @click="refresh">
            <i class="si si-refresh"></i>
          </button>

          <slot name="after-block-options"></slot>
        </div>
      </div>

      <slot name="before-block-content"></slot>

      <div class="block-content" style="padding: 8px 0 0 0;">
        <b-table class="table-vcenter table-responsive" ref="table" hover show-empty :fields="fields" :items="getItems" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc" :empty-text="`Er zijn geen ${itemLabelPlural}`" :empty-filtered-text="`Geen ${itemLabelPlural} gevonden`">
          <template :slot="key" slot-scope="data" v-for="(field, key) in fields">
            <div :key="key">
              <slot :name="key" v-bind="data">{{data.value}}</slot>
            </div>
          </template>
        </b-table>
      </div>

      <slot name="after-block-content"></slot>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: {
    fields: { type: Object, required: true },
    items: { type: Function, required: true },
    defaultSortBy: { type: String, required: true },
    itemLabelSingular: { type: String, default: 'item' },
    itemLabelPlural: { type: String, default: 'items' },
    hideSearchBar: {type: Boolean, default: false}
  },
  data () {
    return {
      totalRows: null,
      perPage: 10,
      currentPage: 1,
      filter: '',
      sortBy: null,
      sortDesc: false
    }
  },
  computed: {
    totalPages () {
      return this.totalRows / this.perPage
    },
    currentStart () {
      return ((this.currentPage - 1) * this.perPage) + 1
    },
    currentEnd () {
      const end = ((this.currentPage - 1) * this.perPage) + this.perPage
      if (end > this.totalRows) {
        return this.totalRows
      }

      return end
    },
    table () {
      return this.$refs.table
    },
    searchInput () {
      return this.$refs.searchInput
    },
    editableFields () {
      return this.fields.filter(field => { return field.editable === true })
    }
  },
  methods: {
    getItems (ctx) {
      const params = {}
      // Limit results per page
      params.per_page = ctx.perPage

      // Add sort param
      if (ctx.sortBy) {
        params[`sort`] = ctx.sortDesc ? ctx.sortBy : '-' + ctx.sortBy
      } else {
        params[`sort`] = '-' + this.defaultSortBy
      }

      // Add search filter params
      if (ctx.filter) {
        const q = ctx.filter.trim()
        params[`filter[search]`] = q
      }
      // Skip pages
      if (ctx.currentPage > 1) {
        params.page = ctx.currentPage
      }

      // Run request
      return this.items(params)
        .then((response) => {
          this.totalRows = response.data.total
          return response.data.data
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het ophalen van de ${this.itemLabelPlural}. Probeer het opnieuw.`, 'error')
          return []
        })
    },
    next () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    previous () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    refresh () {
      this.table.refresh()
    },
    search: debounce(function (e) {
      this.filter = this.searchInput.value
      this.currentPage = 1
    }, 300),
    clearFilter () {
      this.filter = ''
      this.searchInput.value = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// ApiTableBlock.vue?08f2ad54